import { DYNAMICS, TIMELINES, VALUES } from "../lib/api";
import { inputCls, resizeImage } from "../lib/ui";

export const StepBasics = ({ data, update }) => (
  <div>
    <h2 className="font-serif text-3xl sm:text-4xl tracking-tight">First, the essentials.</h2>
    <div className="mt-12 space-y-6 max-w-md">
      <input
        data-testid="onboarding-age-input"
        className={inputCls}
        type="number"
        min="18"
        max="99"
        placeholder="Your age"
        value={data.age}
        onChange={(e) => update({ age: e.target.value })}
      />
      <div className="flex gap-4">
        {["woman", "man", "other"].map((g) => (
          <button
            key={g}
            data-testid={`onboarding-gender-${g}`}
            onClick={() => update({ gender: g })}
            className={`px-6 py-3 border capitalize transition-colors duration-300 ${
              data.gender === g
                ? "bg-[#7A3B3F] text-[#FAF9F6] border-[#7A3B3F]"
                : "border-[#E5E0D8] text-[#5C5C5C] hover:border-[#7A3B3F]"
            }`}
          >
            {g}
          </button>
        ))}
      </div>
      <input
        data-testid="onboarding-location-input"
        className={inputCls}
        placeholder="City, State"
        value={data.location}
        onChange={(e) => update({ location: e.target.value })}
      />
    </div>
  </div>
);

export const StepDynamic = ({ data, update }) => (
  <div>
    <h2 className="font-serif text-3xl sm:text-4xl tracking-tight">
      What kind of partnership do you want?
    </h2>
    <p className="mt-4 text-[#5C5C5C]">This is the heart of Evervow. Be honest.</p>
    <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-4">
      {DYNAMICS.map((d) => (
        <button
          key={d.key}
          data-testid={`onboarding-dynamic-${d.key}`}
          onClick={() => update({ relationship_dynamic: d.key })}
          className={`text-left p-6 border transition-colors duration-300 ${
            data.relationship_dynamic === d.key
              ? "bg-[#7A3B3F] text-[#FAF9F6] border-[#7A3B3F]"
              : "border-[#E5E0D8] hover:border-[#7A3B3F]"
          }`}
        >
          <span className="font-serif text-xl block">{d.label}</span>
          <span
            className={`text-sm mt-2 block ${
              data.relationship_dynamic === d.key ? "text-[#FAF9F6]/80" : "text-[#5C5C5C]"
            }`}
          >
            {d.desc}
          </span>
        </button>
      ))}
    </div>
  </div>
);

export const StepTimeline = ({ data, update }) => (
  <div>
    <h2 className="font-serif text-3xl sm:text-4xl tracking-tight">
      When do you see yourself married?
    </h2>
    <div className="mt-12 space-y-4 max-w-md">
      {TIMELINES.map((t) => (
        <button
          key={t.key}
          data-testid={`onboarding-timeline-${t.key}`}
          onClick={() => update({ marriage_timeline: t.key })}
          className={`w-full text-left px-6 py-4 border transition-colors duration-300 ${
            data.marriage_timeline === t.key
              ? "bg-[#7A3B3F] text-[#FAF9F6] border-[#7A3B3F]"
              : "border-[#E5E0D8] hover:border-[#7A3B3F]"
          }`}
        >
          {t.label}
        </button>
      ))}
    </div>
  </div>
);

export const StepValues = ({ data, update, toggleValue }) => (
  <div>
    <h2 className="font-serif text-3xl sm:text-4xl tracking-tight">What do you stand for?</h2>
    <div className="mt-8 flex flex-wrap gap-3">
      {VALUES.map((v) => (
        <button
          key={v}
          data-testid={`onboarding-value-${v}`}
          onClick={() => toggleValue(v)}
          className={`px-5 py-2.5 border capitalize text-sm transition-colors duration-300 ${
            data.values.includes(v)
              ? "bg-[#4A5D4E] text-[#FAF9F6] border-[#4A5D4E]"
              : "border-[#E5E0D8] text-[#5C5C5C] hover:border-[#4A5D4E]"
          }`}
        >
          {v}
        </button>
      ))}
    </div>
    <textarea
      data-testid="onboarding-bio-input"
      className={`${inputCls} mt-10 min-h-[100px] resize-none`}
      placeholder="Tell your future spouse who you are… (a few sentences)"
      value={data.bio}
      onChange={(e) => update({ bio: e.target.value })}
    />
    <div className="mt-8">
      <label className="text-xs font-semibold uppercase tracking-[0.2em] text-[#5C5C5C]">
        Add a photo (optional)
      </label>
      <div className="mt-4 flex items-center gap-6">
        {data.photo_url && (
          <img
            src={data.photo_url}
            alt="preview"
            className="w-20 h-20 object-cover border border-[#E5E0D8]"
          />
        )}
        <input
          data-testid="onboarding-photo-input"
          type="file"
          accept="image/*"
          onChange={async (e) => {
            const f = e.target.files?.[0];
            if (f) update({ photo_url: await resizeImage(f) });
          }}
          className="text-sm text-[#5C5C5C]"
        />
      </div>
    </div>
  </div>
);
